// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2QaI7","row":"ProcedureTreatmentSummary_row__3nYm8"};